import React, { useState } from 'react';
import cx from 'classnames';
import { find } from 'lodash';
import moment from 'moment';

import { ApplicationDeadline } from '@schools/app/types';

import colors from '@magoosh/lib/styles/colors.module.scss';
import style from './style.module.scss';

interface Props {
  deadlines: ApplicationDeadline[];
}

const ApplicationDeadlineAccordian: React.FC<Props> = (props) => {
  const nextDeadline = find(props.deadlines, (deadline) => {
    const today = moment();
    return moment(deadline.deadlineDate).isSame(today) || moment(deadline.deadlineDate).isAfter(today);
  });
  const [selectedDeadline, setSelectedDeadline] = useState<ApplicationDeadline>(nextDeadline);

  const yearRange = () => {
    if (!props.deadlines.length) return;

    const years = props.deadlines.map((deadline) => parseInt(deadline.deadlineDate.slice(0, 4)));
    const minYear = Math.min(...years);
    const maxYear = Math.max(...years);

    if (minYear === maxYear) {
      return `${minYear}`;
    } else {
      return `${minYear}-${maxYear - 2000}`;
    }
  };

  return (
    <div>
      <h3 className="u-margin-A-n u-margin-B-m">
        {yearRange()} Application Deadlines
      </h3>

      <div className="d-flex flex-column" style={{ gap: 2 }}>
        {
          props.deadlines.map((deadline, idx) => {
            const active = deadline === selectedDeadline;

            return (
              <div
                key={idx}
                className={cx(style.deadline, 'd-flex flex-column', { [style.active]: deadline === selectedDeadline })}
                onClick={() => setSelectedDeadline(deadline)}
                style={{ cursor: active ? 'inherit' : 'pointer', gap: 10 }}
              >
                <div>
                  <div className={cx('small', { 'text-secondary': active, 'text-gray-light': !active })}>
                    <strong>ROUND {idx + 1}</strong>
                  </div>

                  <div style={{ color: colors.grayDarker }}>
                    {
                      active
                        ? <h3 className="u-margin-A-n"><strong>{moment(deadline.deadlineDate).format('MMMM D, YYYY')}</strong></h3>
                        : <strong>{moment(deadline.deadlineDate).format('MMMM D, YYYY')}</strong>
                    }
                  </div>
                </div>

                {
                  deadline.decisionDate && (
                    <div className={style.decision}>
                      <div className={cx({ 'text-secondary': active })} style={{ fontSize: 12 }}>
                        DECISION
                      </div>

                      <div style={{ color: colors.grayDarker }}>
                        <strong>{moment(deadline.decisionDate).format('MMMM D, YYYY')}</strong>
                      </div>
                    </div>
                  )
                }
              </div>
            );
          })
        }
      </div>
    </div>
  );
};

export default ApplicationDeadlineAccordian;
